'use strict';

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.replace");

module.exports = {
  unescape: unescape,
  escape: escape,
  encode: encode,
  decode: decode
};

function unescape(str) {
  return (str + '==='.slice((str.length + 3) % 4)).replace(/-/g, '+').replace(/_/g, '/');
}

function escape(str) {
  return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

function encode(str, encoding) {
  return escape(Buffer.from(str, encoding || 'utf8').toString('base64'));
}

function decode(str, encoding) {
  return Buffer.from(unescape(str), 'base64').toString(encoding || 'utf8');
}